module.exports = __webpack_public_path__ + "img/input_wrap_bg.8a4c304c.png";